import FastFactCard from './FastFactCard';

export default FastFactCard;
